import React, { useState } from 'react';
import { Box, Button, Chip, Collapse, Typography } from '@mui/material';
import { DataObject } from '@mui/icons-material';

const TEMPLATE_VARIABLES = [
  { token: '{{tenant_url}}', label: 'Tenant URL' },
  { token: '{{tenant_admin_email}}', label: 'Admin Email' },
  { token: '{{tenant_admin_password}}', label: 'Admin Password' },
  { token: '{{sharing_portal_url}}', label: 'Skytap Portal URL' },
  { token: '{{skytap_portal_password}}', label: 'Skytap Password' },
];

interface VariableInsertButtonProps {
  onInsert: (token: string) => void;
}

const VariableInsertButton: React.FC<VariableInsertButtonProps> = ({ onInsert }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0.5 }}>
        <Button
          size="small"
          startIcon={<DataObject sx={{ fontSize: 14 }} />}
          onClick={() => setOpen(!open)}
          sx={{
            textTransform: 'none',
            fontSize: '0.75rem',
            color: 'text.secondary',
            '&:hover': { color: 'primary.main' },
          }}
        >
          Variables {open ? '▾' : '▸'}
        </Button>
      </Box>
      <Collapse in={open}>
        <Box sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 0.75,
          mt: 0.5,
          p: 1.5,
          bgcolor: 'grey.50',
          borderRadius: 1,
          border: '1px dashed',
          borderColor: 'grey.300',
        }}>
          <Typography variant="caption" sx={{ color: 'text.secondary', width: '100%', mb: 0.25, fontSize: '0.7rem' }}>
            Click to insert at cursor position:
          </Typography>
          {TEMPLATE_VARIABLES.map((v) => (
            <Chip
              key={v.token}
              label={v.token}
              size="small"
              variant="outlined"
              onClick={() => onInsert(v.token)}
              sx={{
                cursor: 'pointer',
                fontFamily: '"Consolas", monospace',
                fontSize: '0.75rem',
                '&:hover': { bgcolor: 'primary.light', color: 'primary.contrastText', borderColor: 'primary.main' },
              }}
            />
          ))}
        </Box>
      </Collapse>
    </>
  );
};

export default VariableInsertButton;
